import React from "react";

export default function ArrowRight({
  width = "22",
  height = "42",
  stroke = "#606F7B",
  strokeWidth = "2.5"
}) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 22 42"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
    >
      <g id="Canvas" fill="none">
        <g id="Vector">
          <path
            d="M 0 0L 20 20L 40 0"
            strokeWidth={strokeWidth}
            transform="matrix(0 -1 1 0 1 41)"
            stroke={stroke}
          />
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Icons/ArrowRight.js